<template>
  <div class="my-import-file-popup">
    <el-dropdown @command="onCommand">
      <el-button type="primary">
        批量导入<i class="el-icon-upload"></i>
      </el-button>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="3" v-if="isShowCompanyTianyanUpload">
          天眼查导入
        </el-dropdown-item>
        <el-dropdown-item command="1" v-if="isShowInputUpload">
          天眼查导入
        </el-dropdown-item>
        <el-dropdown-item command="2" v-if="isShowLocalUpload">
          本地导入
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <MyDialog
      :title="dialogTitle"
      :isOpen.sync="isVisible"
      @callback="close"
      width="40%"
    >
      <template v-slot:body>
        <div v-if="isVisible" v-loading="loading">
          <div v-if="currentCommand === 1">
            <!-- 多个input上传 还没写的 -->
             <div v-if="listType === 'list-input'"></div>
            <!-- 单个input上传 -->
            <InputUpload  v-else ref="inputUploadRef"></InputUpload>
          </div>
          <div v-else>
            <el-alert
              type="info"
              show-icon
              :closable="false"
            >
              <div slot="title" class="file-template">
                <p v-if="isShowTemplate">
                  请按指定模板上传，<span
                    class="download"
                    @click="downloadTemplate"
                    >点击下载模板</span
                  >。
                </p>
                <p v-else>
                  <span v-if="listType === 'list'">当前仅支持pdf文件。</span>
                </p>
              </div>
            </el-alert>
            <!-- 多个文件列表上传 -->
            <MutliUpload v-if="listType === 'list'" ref="uploadRef" />
            <!-- 单个文件上传 -->
            <SingleUpload v-else ref="uploadRef" />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <el-button
            type="primary"
            @click="onReadySubmit"
            :loading="submitLoading"
          >
            确 定
          </el-button>
          <el-button @click="close()">取 消</el-button>
        </div>
      </template>
    </MyDialog>
  </div>
</template>
<script>
//components
import MyDialog from "@/components/MyDialog/index.vue";
import SingleUpload from "./components/SingleUpload.vue";
import InputUpload from "./components/InputUpload.vue";
import MutliUpload from "./components/MutliUpload.vue";
//api
import { downloadTemplate } from "@/api/common.js"; //文件上传模板

// utils
import { saveAs } from "file-saver";
import { downFile } from "@/utils/tool";
import {
  templateTypes,
  API,
  importFileInterfaceMap,
  tianyanAPI,
  importTianyanMap
} from "./data.js";

export default {
  name: "MyImportFilePopup",
  components: {
    MyDialog,
    SingleUpload,
    MutliUpload,
    InputUpload
  },
  props: {
    // 导入按钮名称
    moduleOriginCnName: {
      type: String,
      default: "企业数据"
    },
    // 是否显示输入关键字导入
    isShowInputUpload: {
      type: Boolean,
      default: true
    },
    // 用于控制是否显示本地导入
    isShowLocalUpload: {
      type: Boolean,
      default: true
    },
    //用于企业数据的天眼查导入
    isShowCompanyTianyanUpload: {
      type: Boolean,
      default: false
    },
    //上传多个的类型
    listType: {
      type: String,
      default: "" // "list"-为列表上传 例如研究报告的多个pdf;"list-input"-为列表输入上传 例如多个链接上传
    }
  },
  computed: {
    //查询当前类型是否有模板
    isShowTemplate() {
      return templateTypes.includes(this.moduleOriginCnName)
    },
    Authorization() {
      return sessionStorage.getItem("token");
    }
  },
  data() {
    return {
      currentCommand: 1, // 1:天眼查导入 2:本地导入
      submitLoading: false, //确认按钮loading
      loading: false,
      isVisible: false,
      dialogTitle: ""
    };
  },
  methods: {
    //开启弹窗
    open() {
      this.isVisible = true;
    },
    // 关闭弹窗
    close() {
      this.isVisible = false;
    },
    // 点击下拉菜单
    onCommand(command) {
      this.isVisible = true;
      this.currentCommand = Number(command);
      this.dialogTitle = `${this.moduleOriginCnName}${
        this.currentCommand === 2 ? "（本地导入）" : "（天眼查导入）"
      }`;
    },
    // 点击提交按钮前的准备
    onReadySubmit() {
      if (this.currentCommand === 1) {
        this.handleKeywordUpload();
        return;
      }

      //数据准备
      const files = this.$refs.uploadRef.submitUpload();
      if (_.isEmpty(files)) return;

      if (this.currentCommand === 3) {
        this.handleCompanyTianyanUpload(files);
        return;
      }
      if (this.listType === "list") {
        this.handleMutliFileUplaod(files);
      } else {
        this.handleSingleFileUplaod(files);
      }
    },
    //关键字导入
    handleKeywordUpload() {
      const form = this.$refs.inputUploadRef.submitForm();
      if (form) {
        this.submitLoading = true;
        const interfaceName = importTianyanMap[this.moduleOriginCnName];
        const interfaceFn = tianyanAPI[interfaceName];
        interfaceFn(form)
          .then(res => {
            this.submitLoading = false;
            if (res.code === 200) {
              this.$message.success("新增成功");
              this.$emit("on-success");
            } else {
              this.$message.warning("新增失败");
            }
          })
          .finally(() => {
            this.submitLoading = false;
          });
      }
    },
    //点击多个文件导入 目前多文件都是pdf
    async handleMutliFileUplaod(files) {
      //参数准备
      const typs = ["行业知识", "论文数据"];
      const fileParmsName = _.includes(typs, this.moduleOriginCnName)
        ? "files"
        : "file";
      //接口准备-根据模块名称获取接口名称
      const interfaceName = importFileInterfaceMap[this.moduleOriginCnName];
      const interfaceFn = API[interfaceName];

      this.$modal.loading("文件上传中，请稍候...");
      this.submitLoading = true;

      // 存储上传失败的文件信息
      const failedFiles = [];

      try {
        // 创建所有文件的上传Promise数组
        const uploadPromises = files.map(file => {
          const formData = new FormData();
          formData.append(fileParmsName, file.raw);
          formData.append("Authorization", this.Authorization);

          return interfaceFn(formData)
            .then(res => {
              if (res && !_.includes([200, 415], res.code)) {
                // 记录上传失败的文件信息
                failedFiles.push({
                  name: file.name,
                  msg: res.msg || "上传失败！"
                });
              }
              return res;
            })
            .catch(err => {
              // 记录上传失败的文件信息
              failedFiles.push({
                name: file.name,
                msg: err.message || "上传异常！"
              });
              return null;
            });
        });

        // 并发上传所有文件
        await Promise.all(uploadPromises);

        this.submitLoading = false;
        this.$modal.closeLoading();

        // 处理上传结果
        if (failedFiles.length > 0) {
          // 构建失败信息HTML
          let failedHtml =
            '<div style="text-align: left;"><p>抱歉，共' +
            files.length +
            "个文件导入失败！失败详情如下：</p><ul>";

          failedFiles.forEach((file, index) => {
            failedHtml += `<li>${index + 1}、${file.name}：${file.msg}</li>`;
          });
          failedHtml += "</ul></div>";

          this.$alert(failedHtml, "提示", {
            dangerouslyUseHTMLString: true
          })
            .then(() => {
              if (failedFiles.length < files.length) {
                // 部分成功时也触发成功事件
                this.$emit("on-success");
              }
              this.$emit("close");
            })
            .catch(() => {});
        } else {
          this.$alert("所有文件上传成功！", "提示", {
            dangerouslyUseHTMLString: true
          })
            .then(() => {
              this.$emit("on-success");
              this.$emit("close");
            })
            .catch(() => {});
        }
      } catch (err) {
        this.submitLoading = false;
        this.$modal.closeLoading();
        this.$message.warning("上传过程中发生异常");
      }
    },
    //点击单个文件导入
    async handleSingleFileUplaod(files) {
      //参数准备
      const typs = ["行业知识", "论文数据"];
      const fileParmsName = _.includes(typs, this.moduleOriginCnName)
        ? "files"
        : "file";
      const formData = new FormData();
      formData.append(fileParmsName, files[0].raw);
      formData.append("Authorization", this.Authorization);
      //接口准备-根据模块名称获取接口名称
      const interfaceName = importFileInterfaceMap[this.moduleOriginCnName];
      const interfaceFn = API[interfaceName];

      this.$modal.loading("文件上传中，请稍候...");
      this.submitLoading = true;

      //调用接口上传接口 获取响应 状态处理
      await interfaceFn(formData)
        .then(res => {
          if (res) {
            this.submitLoading = false;
            this.$modal.closeLoading();
            const isFail = !_.includes([200, 415], res.code);
            const msg = isFail ? "文件上传失败！" : "文件上传成功！";
            this.$alert(res.msg ? res.msg : msg, "提示", {
              dangerouslyUseHTMLString: true
            })
              .then(() => {
                this.$emit("on-success");
                this.$emit("close");
              })
              .catch(() => {});
          }
        })
        .catch(err => {
          if (err) {
            this.submitLoading = false;
            this.$modal.closeLoading();
          }
        });
    },
    //天眼查本地导入
    async handleCompanyTianyanUpload(files) {
      //参数准备
      const typs = ["行业知识", "论文数据"];
      const fileParmsName = _.includes(typs, this.moduleOriginCnName)
        ? "files"
        : "file";
      const formData = new FormData();
      formData.append(fileParmsName, files[0].raw);
      formData.append("Authorization", this.Authorization);
      //接口准备-根据模块名称获取接口名称
      const interfaceName = importTianyanMap[this.moduleOriginCnName];
      const interfaceFn = tianyanAPI[interfaceName];

      this.$modal.loading("文件上传中，请稍候...");
      this.submitLoading = true;

      //调用接口上传接口 获取响应 状态处理
      await interfaceFn(formData)
        .then(res => {
          if (res) {
            this.submitLoading = false;
            this.$modal.closeLoading();
            const isFail = !_.includes([200, 415], res.code);
            const msg = isFail ? "文件上传失败！" : "文件上传成功！";
            this.$alert(res.msg ? res.msg : msg, "提示", {
              dangerouslyUseHTMLString: true
            })
              .then(() => {
                this.$emit("on-success");
                this.$emit("close");
              })
              .catch(() => {});
          }
        })
        .catch(err => {
          if (err) {
            this.submitLoading = false;
            this.$modal.closeLoading();
          }
        });
    },
    //下载文件模板
    async downloadTemplate() {
      this.$modal.loading("正在获取模版，请稍候...");
      await downloadTemplate({ name: this.moduleOriginCnName })
        .then(res => {
          if (res.code === 200 && res.data) {
            const url = res.data.importTemplateUrl;
            const type = res.data.importTemplatetype;
            const fileName = res.data.importTemplateName;
            // saveAs(url, fileName, { type: type });
            downFile(
              { urlStr: url }, // 后台需要的参数
              "/public/downloadUrlFile", // 路径
              type,
              fileName
            );
          }
        })
        .finally(() => {
          this.$modal.closeLoading();
        });
    }
  }
};
</script>
<style lang="less" scoped>
::v-deep .file-template {
  text-align: center;
  user-select: none;
  .download {
    color: #409eff;
    cursor: pointer;
  }
}
</style>
